import { useRef } from 'react';

export type ReactionRefetchRequestTracker = {
	issue: () => number;
	isLatest: (token: number) => boolean;
	acceptResponse: (token: number) => boolean;
};

/** Coordinates reads for one mounted comment without retaining page-lifetime state. */
export function useReactionRefetchRequestTracker(
	cloudId: string,
	contentId: string,
	commentId: string | undefined,
): ReactionRefetchRequestTracker {
	const key = JSON.stringify([cloudId, contentId, commentId]);
	const ref = useRef<{ key: string; tracker: ReactionRefetchRequestTracker }>();
	if (!ref.current || ref.current.key !== key) {
		let latest = 0;
		let latestAccepted = 0;
		ref.current = {
			key,
			tracker: {
				issue: () => ++latest,
				isLatest: (token) => token === latest,
				// Pending requests must not prevent an earlier response from updating the summary.
				acceptResponse: (token) => {
					if (token <= latestAccepted) {
						return false;
					}
					latestAccepted = token;
					return true;
				},
			},
		};
	}
	return ref.current.tracker;
}
